var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"codeEditor",staticClass:"code_editor",style:({
    height: this.editorHeight
  }),attrs:{"id":"codeEditor"}})}
var staticRenderFns = []

export { render, staticRenderFns }